exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.bton {\n  border: 1px solid #ccc;\n  padding: .25em .5em;\n  margin: 0;\n  background: #fff;\n  color: #333;\n  border-radius: .25em;\n}\n.bton:hover {\n  text-decoration: none;\n  background-color: #f0f0f0;\n}\n.\\--small {\n  font-size: .75rem;\n}\n", ""]);

// exports
